<div class="p-1-em content" [scrollHandler]="panelActionsDispatcher">

    <ng-container *ngIf="servicePanelDataSource.pageInfo | async as page">

      <div class="content-text-info">
        <span>
          Total alertas últimas 24 horas <span class="text-color-primary-1">{{ page.totalCount | number:'1.0-0' }}</span>
        </span>
      </div>

    </ng-container>

    <list-cards-notification
    [properties]="gridPageProps"
    ></list-cards-notification>

</div>
